import NetworkingOperations from "../index";

const PaypalGetPaymentData = (data) => {
	const url = process.env.REACT_APP_PAYPAL_GET_PAYMENT_DATA;

	return NetworkingOperations.post({ url, data }).then((res) => res);
};

export default PaypalGetPaymentData;
